import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";
import {SsoConfigModel} from "../../authentication/models/sso-config.model";
import {ContactPersonModel} from "../../commons/models/contact-person.model";

export class IamRequests {

  private readonly baseUrl: any;
  private ssoConfig: SsoConfigModel;

  /* @ngInject */
  constructor(private apiConfig: ApiConfig, private $q: IQService, private $http: IHttpService) {
    this.baseUrl = this.apiConfig.baseUrl + `/iam`;
  }

  // ******************************
  //        Public methods
  // ******************************

  getConfigurationClient() {
    const deferred = this.$q.defer();

    this.$http.get(`${this.baseUrl}/sso/configuration`, {
      params: {
        client: 'Admin'
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }

  emailResetLink(email) {

    const deferred = this.$q.defer();

    const emailResetLinkUrl = this.baseUrl + '/reset';

    this.$http.get(emailResetLinkUrl, {
      params: {
        email: email
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  };

  setSsoConfig(ssoConfig: SsoConfigModel) {
    this.ssoConfig = ssoConfig;
  }

  getSsoConfig() {
    return this.ssoConfig;
  }

  // const emailResetLinkUrl = this.baseUrl + '/reset';
  // return new Promise((resolve, reject) => {
  //     this.$http.get(emailResetLinkUrl, {
  //       params: {
  //         email: email
  //       }
  //     })
  //     .then((response) => {
  //       resolve(response.data);
  //     })
  //     .catch((response) => {
  //       reject(response.data);
  //     });
  // });


  resetPassword(password, token) {

    const deferred = this.$q.defer();

    const resetPasswordUrl = this.baseUrl + '/reset';

    this.$http.post(resetPasswordUrl, {
      password: password,
      token: token
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });
    return deferred.promise;
  };


  getSuperRoles() {

    const deffered = this.$q.defer();
    const getSuperRolesUrl = this.baseUrl + '/policy/roles';

    this.$http.get(getSuperRolesUrl)
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((response) => {
        deffered.reject(response.data);
      });

    return deffered.promise;

  }

  getResources() {

    const deffered = this.$q.defer();
    const getResourcesUrl = this.baseUrl + '/policy/resources';

    this.$http.get(getResourcesUrl)
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((response) => {
        deffered.reject(response.data);
      });


    return deffered.promise;
  }

  getBranches(siteId) {
    const deffered = this.$q.defer();

    const getResourcesUrl = this.baseUrl + '/policy/branches';

    this.$http.get(getResourcesUrl, {
      params: {
        siteId: siteId
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((response) => {
        deffered.reject(response.data);
      });

    return deffered.promise;
  }

  getSuperPolicy() {
    const deffered = this.$q.defer();


    const getSuperPolicyUrl = this.baseUrl + '/policy';

    this.$http.get(getSuperPolicyUrl)
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((response) => {
        deffered.reject(response.data);
      });

    return deffered.promise;
  }

  editUser(userId, data, orgId, siteId, policyId?: string, expirationDays ?: number, removeExpiration?: boolean) {

    const deffered = this.$q.defer();

    const getSuperPolicyUrl = this.baseUrl + '/users/' + userId;

    this.$http.post(getSuperPolicyUrl, {
      user: data,
      policyId,
      expirationDays,
      removeExpiration
    }, {
      params: {
        orgId: orgId,
        siteId: siteId
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((response) => {
        deffered.reject(response.data);
      });

    return deffered.promise;
  }

  getSelfProfile(userId, siteId) {
    const deffered = this.$q.defer();

    const url = this.baseUrl + '/users/profile/selfProfile/' + userId;

    this.$http.get(url, {
      params: {
        siteId: siteId
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((error) => {
        deffered.reject(error);
      });

    return deffered.promise;
  }

  updateSelfProfile(userId, profileData, siteId) {
    const deffered = this.$q.defer();

    const url = this.baseUrl + '/users/profile/selfProfile/' + userId;

    this.$http.post(url, profileData, {
      params: {
        siteId: siteId
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((error) => {
        deffered.reject(error);
      });

    return deffered.promise;
  }

  updateBranchContacts(userId, contactPerson: ContactPersonModel, branchIdToAdd, siteId) {
    const deffered = this.$q.defer();

    const url = this.baseUrl + '/users/profile/selfProfile/' + userId + '/updateBranchContacts';

    this.$http.post(url, contactPerson, {
      params: {
        siteId: siteId,
        branchIdToAdd: branchIdToAdd
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((error) => {
        deffered.reject(error);
      });

    return deffered.promise;
  }

  deleteBranchContacts(userId, branchIdToRemove, siteId) {
    const deffered = this.$q.defer();

    const url = this.baseUrl + '/users/profile/selfProfile/' + userId + '/deleteBranchContacts';

    this.$http.delete(url, {
      params: {
        siteId: siteId,
        branchIdToRemove: branchIdToRemove
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((error) => {
        deffered.reject(error);
      });

    return deffered.promise;
  }

  getUserProfiles(siteId, branchIds?) {
    const deffered = this.$q.defer();

    const url = this.baseUrl + '/users/profile';

    const params: any = {
      siteId: siteId
    };

    if (branchIds) {
      params.branchIds = branchIds;
    }

    this.$http.get(url, {
      params: params
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((error) => {
        deffered.reject(error);
      });

    return deffered.promise;
  }

  updateUserProfile(userId, profileData, siteId) {
    const deffered = this.$q.defer();

    const url = this.baseUrl + '/users/profile/' + userId;

    this.$http.post(url, profileData, {
      params: {
        siteId: siteId
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((error) => {
        deffered.reject(error);
      });

    return deffered.promise;
  }

  getUserBranches(siteId, userId) {
    const deffered = this.$q.defer();

    const getUserBranchesUrl = this.baseUrl + '/users/' + userId + '/branches';

    this.$http.get(getUserBranchesUrl, {
      params: {
        siteId: siteId
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((response) => {
        deffered.reject(response.data);
      });

    return deffered.promise;
  }


  getUserTeams(siteId, userId) {
    const deffered = this.$q.defer();

    const getUserTeamsUrl = this.baseUrl + '/users/' + userId + '/teams';

    this.$http.get(getUserTeamsUrl, {
      params: {
        siteId: siteId
      }
    })
      .then((response) => {
        deffered.resolve(response.data);
      })
      .catch((response) => {
        deffered.reject(response.data);
      });

    return deffered.promise;
  }

  uploadFile(file) {
    return {
      url: this.baseUrl + '/files',
      method: 'PUT',
      data: {
        file: file
      }
    }
  }

}

angular
  .module('bringoz.admin.iam')
  .service('IamRequests', IamRequests);
